import { t } from "i18next";

const options = {
  filterType: "checkbox",
  filter: false,
  responsive: "standard",
  print: false,
  download: false,
  selectableRows: "none",
  rowsPerPageOptions: [10, 50, 100, 200, 1000],
  rowsPerPage: 5,
  searchAlwaysOpen: true,
  displayRows: false,
  textLabels: {
    body: {
      noMatch: t("NoData_Page"),
      toolTip: t("Sort"),
      columnHeaderTooltip: (column) => `${t("Sort")} ${column.label}`,
    },
    pagination: {
      next: t(""),
      previous: t(""),
      rowsPerPage: t(""),
    },

    viewColumns: {
      title: t("ShowColumn"),
    },
  },
};

export default options;
